import { render, staticRenderFns } from "./moveDialog.vue?vue&type=template&id=126418ea"
import script from "./moveDialog.vue?vue&type=script&lang=js"
export * from "./moveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports